import React from 'react'
import { PageProps } from 'gatsby'
import { AppPageContent } from '../common/AppPageContent'

export interface DefaultHeadProps extends PageProps<any, AppPageContent> {
  className?: string
}

export const DefaultHead = (props: DefaultHeadProps) => {
  const className = props.className || 'bg-gray-50'

  return (
    <>
      <html lang={props.pageContext.locale} />

      <title>{props.pageContext.title}</title>

      {props.pageContext.description && (
        <meta name="description" content={props.pageContext.description} />
      )}
      {props.pageContext.keywords && <meta name="keywords" content={props.pageContext.keywords} />}

      <body className={className} />
    </>
  )
}
